import { TAutoReplyMessageAsset } from 'api';
import { sendAllMessageStrings } from 'constants/strings';
import { DraftMessage, EContentSectionType } from 'types';
import { previewNameInsertion } from 'utils/nameInsertion';

/** 下書き・配信予約に共通のプレビュー文言。sections だけを見るため両方から使える */
export function getDraftPreviewLabel(
  draft: Pick<DraftMessage, 'sections'>,
  assets: TAutoReplyMessageAsset[],
): string {
  const firstSection = draft.sections[0];

  if (!firstSection) return sendAllMessageStrings.drafts.preview.empty;

  switch (firstSection.type) {
    case EContentSectionType.TEXT: {
      if (!firstSection.content) {
        return sendAllMessageStrings.drafts.preview.empty;
      }
      const content = previewNameInsertion(firstSection.content);
      return content.substring(0, 50) + (content.length > 50 ? '...' : '');
    }
    case EContentSectionType.IMAGE:
      return sendAllMessageStrings.drafts.preview.image;
    case EContentSectionType.VIDEO:
      return sendAllMessageStrings.drafts.preview.video;
    case EContentSectionType.FILE:
      return sendAllMessageStrings.drafts.preview.file;
    case EContentSectionType.SURVEY:
      return sendAllMessageStrings.drafts.preview.survey;
    case EContentSectionType.RICH_MESSAGE:
    case EContentSectionType.CARD_TYPE_MESSAGE: {
      const expectedType =
        firstSection.type === EContentSectionType.RICH_MESSAGE
          ? 'RICH_MESSAGE'
          : 'CARD_TYPE_MESSAGE';
      const typeLabel =
        firstSection.type === EContentSectionType.RICH_MESSAGE
          ? sendAllMessageStrings.drafts.preview.richMessage
          : sendAllMessageStrings.drafts.preview.cardTypeMessage;
      const asset = assets.find(
        (candidate) =>
          candidate.id === firstSection.assetId &&
          candidate.type === expectedType,
      );

      return asset ? `${typeLabel}：${asset.name}` : typeLabel;
    }
    default:
      return sendAllMessageStrings.drafts.preview.empty;
  }
}
